module.exports = __webpack_public_path__ + "img/dzjy-logo.9dd22c19.png";